var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('out-put-page',{attrs:{"title":"Nous et notre projet","sectionRef":"notre_project"},on:{"page-updated":_vm.handleAfterRender}},[_c('section',[_c('h3',[_vm._v("Notre projet")]),_c('notre-project',{attrs:{"entreprise":_vm.entrepriseInfo,"project":_vm.projectInfo}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }